/**
 * O som do aviso — F205. Dois bipes curtos, gerados na hora (WebAudio): sem
 * arquivo para baixar, e funciona no desktop sem internet.
 *
 * O navegador só deixa tocar depois de alguma interação com a página; antes
 * disso, falha calado — o aviso na tela continua lá.
 */
export const playChime = (): void => {
  try {
    const AudioContextClass = window.AudioContext as
      typeof AudioContext | undefined
    if (AudioContextClass === undefined) return
    const context = new AudioContextClass()
    const beep = (at: number, frequency: number): void => {
      const oscillator = context.createOscillator()
      const gain = context.createGain()
      oscillator.frequency.value = frequency
      gain.gain.setValueAtTime(0.2, context.currentTime + at)
      gain.gain.exponentialRampToValueAtTime(
        0.001,
        context.currentTime + at + 0.18
      )
      oscillator.connect(gain).connect(context.destination)
      oscillator.start(context.currentTime + at)
      oscillator.stop(context.currentTime + at + 0.2)
    }
    beep(0, 880)
    beep(0.22, 1320)
    window.setTimeout(() => {
      void context.close()
    }, 1000)
  } catch {
    // Sem som não é motivo para quebrar a tela.
  }
}
